module.exports = __webpack_public_path__ + "assets/3045443b4bd0d28886103b272f4d6eb2.jpg";